module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062258236_Contents#r_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Epigraph")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('i', [_vm._v("And ye lucky livers, to whom, by some rare fatality, your Cape Horns are placid as Lake Lemans, flatter not yourselves that good luck is judgment and discretion; for all the yolk in your eggs, you might have foundered and gone down, had the Spirit of the Cape said the word.")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_attr"
  }, [_vm._v("—HERMAN MELVILLE, “ROUNDING CAPE HORN”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71dc7db5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062258236_Epigraph.vue
// module id = 66
// module chunks = 0